export const GET_CATALOG_HEADER_NAVIGATION_ENDPOINT = '/productreviews/GetCatalogHeaderNavigation?productPageId=';